import axios from 'axios';
import Router from '../router'
import Vue from 'vue'

const http = axios.create({
  baseURL: '', // API的基础路径
  timeout: 60000, // 请求超时时间
});

const vueInstance = new Vue()
// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  console.log('响应拦截')
  // vueInstance.$message.info("请求数据成功");
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  // this.$message.warning('请求失败')
  const { config, response } = error;
  switch (response.status) {
    case 401: {
      const msg = response.headers.msg;
      vueInstance.$message.warning("请重新登录");
      // token失效，重新登录
      Router.push('/')
      break
    }
    case 404: {
      // 接口未找到
      vueInstance.$message.error("接口未找到");
      return Promise.reject(error);
    }
    case 500: {
      // 服务器内部错误
      vueInstance.$message.error("服务器内部错误");
      return Promise.reject(error);
    }
    default:
      // 未知错误
      vueInstance.$message.error("未知错误");
      return Promise.reject(error);
  }

});

export default http;